interface GoogleEmbedPreviewProps {
  embedUrl: string;
  title?: string;
  className?: string;
}

export function GoogleEmbedPreview({ embedUrl, title, className = '' }: GoogleEmbedPreviewProps) {
  return (
    <div className={`rounded-lg border overflow-hidden bg-white dark:bg-gray-900 ${className}`}>
      <iframe
        src={embedUrl}
        title={title || 'Google preview'}
        className="w-full h-[420px] border-0"
        allow="autoplay"
        loading="lazy"
      />
    </div>
  );
}
